import React, { useEffect, useState } from "react";
import RichText from "components/rich-text";
import Image from "components/image";
import Button from "helpers/button";
import GoogleReviewsWidget from "components/google-reviews-widget";
import { useWindowDimensions } from "helpers/useWindowDimensions";

const HeroLandingPage = ({ data }) => {
  const { width } = useWindowDimensions();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (width < 768 && !isMobile) setIsMobile(true);
    if (width > 768 && isMobile) setIsMobile(false);
  }, [width]);

  return (
    <div className="relative">
      <div
        className="relative"
        style={{
          backgroundColor: data.overlayColor.hex,
        }}
      >
        {data?.image && (
          <div className="w-full h-full absolute top-0 left-0 flex justify-end sm:relative">
            <div className="relative w-7/12 flex sm:w-full">
              {width > 0 && (
                <div
                  style={{
                    background: `linear-gradient(${
                      isMobile ? "0deg" : "90deg"
                    },  ${data.overlayColor.hex} ${
                      isMobile ? "0%" : "10%"
                    }, transparent 109.82%)`,
                  }}
                  className="w-full h-full absolute top-0 left-0 z-[2]"
                />
              )}
              <img
                src={data.image?.src}
                alt={data.image?.alt}
                className="w-full object-cover"
              />
            </div>
          </div>
        )}

        <div className="container relative w-full pt-40 pb-40 z-[2] sm:pt-0 sm:pb-24">
          <div className="w-1/2 sm:w-full md:w-full">
            <div className="text-white text-7xl font-bold font-display mb-6 sm:text-h1 sm:mb-4">
              <RichText value={data.title.data} />
            </div>

            <div className="paragraph-lg-normal text-gray-300 my-6 sm:my-4">
              <RichText value={data.content.data} />
            </div>

            {data?.buttons && (
              <div className="flex items-center gap-4 sm:flex-wrap">
                {data.buttons.map((button, index) => (
                  <Button button={button} key={index} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <GoogleReviewsWidget />
    </div>
  );
};

export default HeroLandingPage;
